export const PRESETS = {
  avery5160: { label: "Avery 5160 / 8160 (30 per sheet)", sheet: { page_w: 8.5, page_h: 11, cols: 3, rows: 10, label_w: 2.625, label_h: 1, margin_top: 0.5, margin_left: 0.1875, gap_x: 0.125, gap_y: 0 } },
  avery5167: { label: "Avery 5167 (80 per sheet)", sheet: { page_w: 8.5, page_h: 11, cols: 4, rows: 20, label_w: 1.75, label_h: 0.5, margin_top: 0.5, margin_left: 0.3, gap_x: 0.3, gap_y: 0 } },
  avery5163: { label: "Avery 5163 (10 per sheet)", sheet: { page_w: 8.5, page_h: 11, cols: 2, rows: 5, label_w: 4, label_h: 2, margin_top: 0.5, margin_left: 0.15625, gap_x: 0.1875, gap_y: 0 } },
  avery22806: { label: "Avery 22806 square 2\" (12 per sheet)", sheet: { page_w: 8.5, page_h: 11, cols: 3, rows: 4, label_w: 2, label_h: 2, margin_top: 0.625, margin_left: 0.625, gap_x: 0.625, gap_y: 0.625 } },
};

export const ELEMENTS = { logo: "Logo", biz: "Business name", phones: "Phone numbers", number: "Sticker number", service: "Service date", tech: "Tech", due: "Next due", text: "Your own text" };

export const FONTS = ["Arial", "Helvetica", "Verdana", "Tahoma", "Trebuchet MS", "Georgia", "Times New Roman", "Courier New", "Impact"];

export const COLORS = ["#000000", "#1f2937", "#b91c1c", "#c2410c", "#15803d", "#1d4ed8", "#6d28d9"];

export const SIZES = [["S", 7], ["M", 9], ["L", 12]];

export const DEFAULT_DECOR = { border: false, border_color: "#1d4ed8", border_width: 1.5, stripe: "none", stripe_color: "#1d4ed8", stripe_size: 0.12, logo_bg: false, logo_bg_opacity: 0.25 };

export const SAMPLE = { number: "6301A", service: "10/28/2026", tech: "GB", next: "Jan 2027" };

export const newDesign = () => ({
  name: "New sticker",
  sheet: { ...PRESETS.avery5160.sheet },
  template_opacity: 0.5,
  decor: { ...DEFAULT_DECOR },
  elements: [
    { key: "logo", x: 0.08, y: 0.12, size: 54, bold: false, text: "" },
    { key: "biz", x: 0.9, y: 0.06, size: 9, bold: true, text: "" },
    { key: "phones", x: 0.9, y: 0.22, size: 6.5, bold: false, text: "" },
    { key: "number", x: 0.9, y: 0.34, size: 12, bold: true, text: "" },
    { key: "service", x: 0.9, y: 0.58, size: 7.5, bold: false, text: "" },
    { key: "tech", x: 1.9, y: 0.58, size: 7.5, bold: false, text: "" },
    { key: "due", x: 0.9, y: 0.74, size: 8, bold: true, text: "" },
  ],
});

export const elementText = (el, data, biz) => ({
  biz: biz.company_name || "Business name",
  phones: [biz.phone, biz.toll_free].filter(Boolean).join(" · ") || "Phone",
  number: el.text ? `${el.text} ${data.number}` : `${data.number}`,
  service: `Serviced: ${data.service || "______"}`,
  tech: `Tech: ${data.tech || "___"}`,
  due: `Next due: ${data.next || "__________"}`,
  text: el.text || "Text",
}[el.key]);

export const labelOrigin = (sheet, i) => {
  const r = i % sheet.rows;
  const c = Math.floor(i / sheet.rows) % sheet.cols;
  return { left: sheet.margin_left + c * (sheet.label_w + sheet.gap_x), top: sheet.margin_top + r * (sheet.label_h + sheet.gap_y) };
};
